export default "__VITE_ASSET__CQesHBuo__"